// src/i18n/br.ts
export const br = {
  landing: {
    verifying: 'Verificando convite...',
    invalidTitle: 'Convite inválido',
    validTitle: 'Convite válido',
    typeFace: 'Cadastro Facial',
    typeAccount: 'Criação de Conta',
    expires: 'Expira:',
    start: 'Começar',
  },
  identity: {
    step: 'Etapa 1 de 2',
    title: 'Verificação de identidade',
    subtitle: 'Digite os dados exatos do seu documento.',
    country: 'País',
    countryPlaceholder: 'Selecionar...',
    idType: 'Tipo de documento',
    idTypePlaceholder: 'Selecionar...',
    number: 'Número',
    numberPlaceholder: 'Ex: 12345678',
    verify: 'Verificar identidade',
    verifying: 'Verificando...',
  },
  enroll: {
    title: 'Cadastro facial',
    completed: 'concluídas',
    of: 'de',
    completionTitle: 'Cadastro completo!',
    completionMessage: 'Deseja finalizar o cadastro ou modificar alguma imagem?',
    finish: 'Finalizar',
    modify: 'Modificar',
    positionStart: 'Começar',
    infoTitle: 'Prepare o ambiente',
    infoSubtitle: 'Para obter as melhores fotos, siga estas recomendações:',
    infoStand: 'Pare em frente à câmera a uma distância de 30-50 cm.',
    infoBackground: 'Procure um fundo branco ou de cor neutra.',
    infoLook: 'Olhe fixamente para a câmera sem óculos de sol ou boné.',
    infoLight: 'Certifique-se de ter boa iluminação frontal.',
    infoStart: 'Começar cadastro',
    positions: {
      FRONT: { name: 'Frente', hint: 'Olhe direto para a câmera', instruction: 'Olhe direto para a câmera com a cabeça quieta' },
      UP: { name: 'Cima', hint: 'Incline levemente a cabeça para cima', instruction: 'Incline levemente a cabeça para cima' },
      DOWN: { name: 'Baixo', hint: 'Incline levemente a cabeça para baixo', instruction: 'Incline levemente a cabeça para baixo' },
      LEFT: { name: 'Esquerda', hint: 'Vire um pouco a cabeça para a esquerda', instruction: 'Vire um pouco a cabeça para a esquerda' },
      RIGHT: { name: 'Direita', hint: 'Vire um pouco a cabeça para a direita', instruction: 'Vire um pouco a cabeça para a direita' },
    },
  },
  camera: {
    noFace: 'Aproxime seu rosto da câmera',
    notCentered: 'Centralize seu rosto no quadro',
    wrongPose: 'Ajuste a posição da sua cabeça',
    blink: 'Pisque uma vez',
    holdPose: 'Mantenha a pose...',
    perfect: 'Perfeito! Capturando...',
    usePhoto: 'Usar esta foto?',
    retake: 'Tirar novamente',
    confirm: 'Usar foto',
    uploading: 'Enviando foto...',
    retryUpload: 'Tentar enviar novamente',
    cameraError: 'Problema com a câmera',
    retry: 'Tentar novamente',
  },
  liveness: {
    face: 'Rosto detectado',
    centered: 'Centralizado',
    pose: 'Posição correta',
    blink: 'Piscar',
    hold: 'Manter pose',
  },
  account: {
    step: 'Etapa 2 de 2',
    title: 'Crie sua senha',
    subtitle: 'Defina a senha da sua conta. Depois você poderá entrar com seu documento ou email.',
    password: 'Senha',
    passwordPlaceholder: 'Mínimo 8 caracteres',
    confirm: 'Confirmar senha',
    confirmPlaceholder: 'Repita sua senha',
    email: 'Email (opcional)',
    emailPlaceholder: 'voce@email.com',
    emailHint: 'Você poderá usá-lo para entrar e receber notificações.',
    mismatch: 'As senhas não coincidem',
    tooShort: 'A senha deve ter pelo menos 4 caracteres',
    invalidEmail: 'Formato de email inválido',
    submit: 'Ativar conta',
    submitting: 'Ativando...',
  },
  summary: {
    title: 'Cadastro concluído!',
    subtitle: 'Seu rosto foi registrado com sucesso.',
    titleAccount: 'Conta ativada!',
    subtitleAccount: 'Sua senha foi registrada. Você já pode acessar a plataforma.',
    finish: 'Finalizar',
  },
  errors: {
    invalidInvitation: 'Convite inválido',
    verifyIdentity: 'Erro ao verificar identidade',
    activateAccount: 'Erro ao ativar a conta',
    missingContext: 'Contexto de cadastro ausente',
  },
} as const